<!-- eslint-disable indent -->
<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col cols="6">
          <h4>Certificados</h4>
          <fieldset class="font-weight-bold text-muted small">
            Visualize os certificados dessa empresa aqui
          </fieldset>
        </b-col>
        <b-form-group class="col-6 my-0 pb-0">
          <b-form-checkbox
            v-model="empresa.exibirCertificadoVencidoECnpj"
            class="custom-control-primary"
            style="float:right"
            name="check-button"
            switch
            @change="getCertificados"
          >
            <label style="font-size: 1rem">Exibir certificados vencidos</label>
          </b-form-checkbox>
        </b-form-group>
      </b-row>
      <b-row>
        <b-col cols="12">
          <hr
            class="mx-0 mt-0 mb-2"
            style="border-top: 1px solid #a3a4a66b !important;"
          >
        </b-col>
      </b-row>
      <b-row
        v-if="certificados && certificados.length > 0"
        style="display: flex; flex-direction: column;"
      >
        <b-col
          v-for="certificado in certificados"
          :key="certificado.id"
        >
          <dados-certificado
            :value="certificado"
          />
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>
          <dados-certificado
            :value="{}"
          />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex'
import apiCertificado from '@/app-modulo/comuns/certificado/shared/services/api'

export default {
  name: 'AbaCertificados',
  components: {
    DadosCertificado: () => import('./shared/dados-certificado/DadosCertificado.vue'),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      certificados: [],
    }
  },
  created() {
    this.getCertificados()
  },
  computed: {
    ...mapGetters('empresa', ['empresa']),
  },
  methods: {
    getCertificados() {
      const empresaId = this.$route.params.id
      if (empresaId && empresaId > 0) {
        const certVencido = this.empresa.exibirCertificadoVencidoECnpj === undefined ? false : this.empresa.exibirCertificadoVencidoECnpj
        apiCertificado.getCertificadoByEmpresaId(empresaId, certVencido)
          .then(payload => {
            this.certificados = payload.data
          })
          .catch(err => {
            this.$erro(err)
          })
      }
    },
  },
}
</script>
